export const ADDRESS_FULLY_VERIFIED = 'AS01'
export const ADDRESS_ERROR_PREFIX = 'AE'
